import axios from 'axios';

export const getReportCompanies = async (queryString = '') => {
    try {
        const response = await axios
            .get(`/api/admin/report/companies?${queryString}`, {
                headers: {
                    "Content-Type": "application/json"
                },
            })
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export const getReportCandidates = async (queryString = '') => {
    try {
        const response = await axios
            .get(`/api/admin/report/candidates?${queryString}`, {
                headers: {
                    "Content-Type": "application/json"
                },
            })
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

export const getReportCompany = async (id = '') => {
    try {
        const response = await axios
            .get(`/api/admin/report/companies/${id}`, {
                headers: {
                    "Content-Type": "application/json"
                },
            })
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};